import Router from 'vue-router'
import { getAuthState, store } from './index'
// const subPage = {
//   template: '<router-view></router-view>'
// }

export default class extends Router {
  constructor (arg) {
    super(arg)
    this.map({
      '/login': {
        component: require('./components/pages/Login.vue'),
        noauth: true
        // noloading: true
      },
      '/products': {
        component: require('./components/pages/Products.vue')
      },
      '/pt-firmware': {
        name: 'pt-firmware',
        component: require('./components/pages/PTFirmware.vue')
      },
      '/privateMIB': {
        component: require('./components/pages/Private_MIB.vue')
      },
      '/privateMIB/v2': {
        component: require('./components/pages/Private_MIB_V2.vue')
      },
      '/license': {
        component: require('./components/pages/License.vue')
      },
      '/mt-download': {
        component: require('./components/pages/FirmwareDownload.vue')
      },
      '/pt-bootloader': {
        name: 'pt-bootloader',
        component: require('./components/pages/PTBootloader.vue')
      },
      '/mt-firmware': {
        name: 'mt-firmware',
        component: require('./components/pages/MTFirmware.vue')
      },
      '/mt-bootloader': {
        name: 'mt-bootloader',
        component: require('./components/pages/MTBootloader.vue')
      }
    })
    this.beforeEach(({ to, next, abort }) => {
      if (to.matched === null) {
        getAuthState().then(state => {
          abort()
          if (state) {
            const target = store.state.user.role === 'manufacturer' ? '/mt-download' : '/products'
            this.replace(target)
          } else {
            this.replace('/login')
          }
        })
      } else if (to.noauth) {
        next()
      } else {
        getAuthState().then(state => {
          if (state) {
            if ((store.state.user.role === 'manufacturer' && to.path !== "/mt-download")) {
              abort()
              this.replace('/mt-download')
            }
            return next()
          }
          abort()
          this.replace('/login')
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/Router.js